import _ from 'lodash'

import httpService from '../../../services/httpService'
import ToasterService from '../../../services/toasterService'

const baseTypes = {
  SUCCESS: '_SUCCESS',
  FAILURE: '_FAILURE',
  REQUEST: '_REQUEST'
}

export const types = {
  GET_USER_LIST_BY_CLIENT: 'user-management/GET_USER_LIST_BY_CLIENT',
  CLEAR_USER_DATA: 'user-management/CLEAR_USER_DATA',
  UPDATE_USER_STATUS: 'users-management/UPDATE_USER_STATUS',
  UPDATE_USER_ROLE: 'user-management/UPDATE_USER_ROLE',
  INVITE_USER: 'user-management/INVITE_USER',
  FIND_USER_BY_EMAIL: 'user-management/FIND_USER_BY_EMAIL',
  INVITE_NEW_USER: 'user-management/INVITE_NEW_USER',
  INVITE_EXISTING_USER: 'user-management/INVITE_EXISTING_USER',
}

const state = {
  users: [],
  usersCopy: [],
  isDataFetching: true,
  isUserUpdating: false,
  isUserInviting: false,
  isUserSearching: false,
  isError: false
}

const mutations = {
  [`${types.GET_USER_LIST_BY_CLIENT}${baseTypes.REQUEST}`]: function (state) {
    state.isDataFetching = true
    state.isError = false
  },
  [`${types.GET_USER_LIST_BY_CLIENT}${baseTypes.FAILURE}`]: function (state) {
    state.isDataFetching = false
    state.isError = true
  },
  [`${types.GET_USER_LIST_BY_CLIENT}${baseTypes.SUCCESS}`]: function (state, { users }) {
    // TODO: remove this when problem with duplicates is resolved
    state.isDataFetching = false
    state.isError = false
    state.users = _.uniqBy(users, user => user._id)
    // TODO: ref-50 I did this because I didnt have time to implement this via previous/current role_id. It should be reworked during refactoring
    state.usersCopy = _.cloneDeep(state.users)
  },
  [`${types.UPDATE_USER_STATUS}${baseTypes.REQUEST}`]: function (state) {
    state.isUserUpdating = true
    state.isError = false
  },
  [`${types.UPDATE_USER_STATUS}${baseTypes.FAILURE}`]: function (state) {
    state.isUserUpdating = false
    state.isError = true
  },
  [`${types.UPDATE_USER_STATUS}${baseTypes.SUCCESS}`]: function (state, { userId, active }) {
    state.isUserUpdating = false
    state.isError = false
    state.users = state.users
      .map(user => user._id === userId ? Object.assign(user, { active }) : user)
  },
  [`${types.UPDATE_USER_ROLE}${baseTypes.REQUEST}`]: function (state) {
    state.isUserUpdating = true
    state.isError = false
  },
  [`${types.UPDATE_USER_ROLE}${baseTypes.FAILURE}`]: function (state) {
    state.isUserUpdating = false
    state.isError = true
    // TODO: ref-50 I did this because I didnt have time to implement this via previous/current role_id. It should be reworked during refactoring
    state.users = _.cloneDeep(state.usersCopy)
  },
  [`${types.UPDATE_USER_ROLE}${baseTypes.SUCCESS}`]: function (state, { userId, roleId, roleLabel }) {
    state.isUserUpdating = false
    state.isError = false
    state.users = state.users
      .map(user => user._id === userId ? Object.assign(user, { role_id: roleId, user_role: roleLabel }) : user)
  },
  [`${types.INVITE_USER}${baseTypes.REQUEST}`]: function (state) {
    state.isUserInviting = true
    state.isError = false
  },
  [`${types.INVITE_USER}${baseTypes.FAILURE}`]: function (state) {
    state.isUserInviting = false
    state.isError = true
  },
  [`${types.INVITE_USER}${baseTypes.SUCCESS}`]: function (state) {
    state.isUserInviting = false
    state.isError = false
  },
  [types.CLEAR_USER_DATA]: function (state) {
    state.users = []
  },
  [`${types.FIND_USER_BY_EMAIL}${baseTypes.REQUEST}`]: function (state) {
    state.isUserSearching = true
    state.isError = false
  },
  [`${types.FIND_USER_BY_EMAIL}${baseTypes.SUCCESS}`]: function (state) {
    state.isUserSearching = false
    state.isError = false
  },
  [`${types.INVITE_NEW_USER}${baseTypes.REQUEST}`]: function (state) {
    state.isUserInviting = true
    state.isError = false
  },
  [`${types.INVITE_NEW_USER}${baseTypes.SUCCESS}`]: function (state) {
    state.isUserInviting = false
    state.isError = false
  },
  [`${types.INVITE_NEW_USER}${baseTypes.FAIL}`]: function (state) {
    state.isUserInviting = false
    state.isError = true
  },
  [`${types.INVITE_EXISTING_USER}${baseTypes.REQUEST}`]: function (state) {
    state.isUserInviting = true
    state.isError = false
  },
  [`${types.INVITE_EXISTING_USER}${baseTypes.SUCCESS}`]: function (state) {
    state.isUserInviting = false
    state.isError = false
  },
  [`${types.INVITE_EXISTING_USER}${baseTypes.FAIL}`]: function (state) {
    state.isUserInviting = false
    state.isError = true
  },
}

const actions = {
  getUsersByClient: async function ({ commit  }, { clientId, clearData = true }) {
    commit(`${types.GET_USER_LIST_BY_CLIENT}${baseTypes.REQUEST}`)
    clearData && commit(types.CLEAR_USER_DATA)
    try {
      const response = await httpService.get(`/clients/${clientId}/users`, { raiseError: true, cancelErrorMessage: true })
      if (response.data.errors.length) {
        commit(`${types.GET_USER_LIST_BY_CLIENT}${baseTypes.FAILURE}`)
        ToasterService.showToast(ToasterService.ERROR_TYPE, response.data.errors[0])
      }
      commit(`${types.GET_USER_LIST_BY_CLIENT}${baseTypes.SUCCESS}`, { users: response.data.users })
    } catch (error) {
      commit(`${types.GET_USER_LIST_BY_CLIENT}${baseTypes.FAILURE}`)
      ToasterService.showToast(ToasterService.ERROR_TYPE, error)
    }
  },
  updateUserStatus: async function ({ commit }, { clientId, userId, active }) {
    commit(`${types.UPDATE_USER_STATUS}${baseTypes.REQUEST}`)
    try {
      const response = await httpService.patch(`/clients/${clientId}/users/${userId}/status`, { active }, { raiseError: true, cancelErrorMessage: true })
      if (response.data.errors.length) {
        commit(`${types.UPDATE_USER_STATUS}${baseTypes.FAILURE}`)
        ToasterService.showToast(ToasterService.ERROR_TYPE, response.data.errors[0])
      }
      commit(`${types.UPDATE_USER_STATUS}${baseTypes.SUCCESS}`, { userId, active })
      ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'User status is successfully changed!')
    } catch (error) {
      commit(`${types.UPDATE_USER_STATUS}${baseTypes.FAILURE}`)
      ToasterService.showToast(ToasterService.ERROR_TYPE, error)
    }
  },
  updateUserRole: async function ({ commit }, { userId, clientId, roleId, roleLabel }) {
    commit(`${types.UPDATE_USER_ROLE}${baseTypes.REQUEST}`)
    try {
      const response = await httpService.patch(`/clients/${clientId}/users/${userId}/role`, { role_id: roleId }, { raiseError: true, cancelErrorMessage: true })
      if (response.data.errors.length) {
        commit(`${types.UPDATE_USER_ROLE}${baseTypes.FAILURE}`)
        ToasterService.showToast(ToasterService.ERROR_TYPE, response.data.errors[0])
      }
      commit(`${types.UPDATE_USER_ROLE}${baseTypes.SUCCESS}`, { userId, roleId, roleLabel })
      ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'User role is successfully updated!')
    } catch (error) {
      commit(`${types.UPDATE_USER_ROLE}${baseTypes.FAILURE}`)
      ToasterService.showToast(ToasterService.ERROR_TYPE, error)
    }
  },
  inviteUser: async function ({ commit, dispatch }, { email, roleId, clientId, lastName, firstName }) {
    commit(`${types.INVITE_USER}${baseTypes.REQUEST}`)
    try {
      const response = await httpService.post(
        `/clients/${clientId}/invite-user`,
        { email, last_name: lastName, first_name: firstName, role_id: roleId },
        { raiseError: true, cancelErrorMessage: true }
        )
        if (response.data.errors.length) {
          commit(`${types.INVITE_USER}${baseTypes.FAILURE}`)
          ToasterService.showToast(ToasterService.ERROR_TYPE, response.data.errors[0])
        }
        commit(`${types.INVITE_USER}${baseTypes.SUCCESS}`, { clientId })
        dispatch('getUsersByClient', { clientId })
        ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'User is successfully invited!')
      } catch (error) {
        commit(`${types.INVITE_USER}${baseTypes.FAILURE}`)
        ToasterService.showToast(ToasterService.ERROR_TYPE, error)
      }
    },
    findUserByEmail: async function ({ commit }, { email, clientId }) {
      commit(`${types.FIND_USER_BY_EMAIL}${baseTypes.REQUEST}`)
      const params = { email }
      const response = await httpService.get(`/clients/${clientId}/project-invitation`, { params, cancelErrorMessage: true })
      commit(`${types.FIND_USER_BY_EMAIL}${baseTypes.SUCCESS}`)
      
      return response.data
    },
    inviteNewUser: async function({ commit }, { clientId, email, firstName, lastName, roleId }) {
      commit(`${types.INVITE_NEW_USER}${baseTypes.REQUEST}`)
      const params = {
        email,
        first_name: firstName,
        last_name: lastName,
        role_id: roleId
      }

      let response
      try {
        response = await httpService.post(`/clients/${clientId}/project-invitation`, { params })
        commit(`${types.INVITE_NEW_USER}${baseTypes.SUCCESS}`)
      } catch (error) {
        commit(`${types.INVITE_NEW_USER}${baseTypes.FAILURE}`)
      }

      return response
    },
    inviteNewUser: async function({ commit }, { clientId, email, firstName, lastName, roleId }) {
      commit(`${types.INVITE_NEW_USER}${baseTypes.REQUEST}`)
      const params = {
        email,
        firstName,
        lastName,
        roleId
      }

      let response
      try {
        response = await httpService.post(`/clients/${clientId}/project-invitation`, params, { isFormData: true })
        commit(`${types.INVITE_NEW_USER}${baseTypes.SUCCESS}`)
      } catch (error) {
        commit(`${types.INVITE_NEW_USER}${baseTypes.FAILURE}`)
      }

      return response
    },
    inviteExistingUser: async function({ commit }, { clientId, id, roleId }) {
      commit(`${types.INVITE_EXISTING_USER}${baseTypes.REQUEST}`)
      const params = {
        id,
        roleId
      }

      let response
      try {
        response = await httpService.patch(`/clients/${clientId}/project-invitation`, params, { isFormData: true })
        commit(`${types.INVITE_EXISTING_USER}${baseTypes.SUCCESS}`)
      } catch (error) {
        commit(`${types.INVITE_EXISTING_USER}${baseTypes.FAILURE}`)
      }

      return response
    },
  }
  

/**
 * Store for manage user's & them role's
*/
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
